"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _store = _interopRequireDefault(require("./store"));

var _storeMapa = _interopRequireDefault(require("./store-mapa"));

var _cloneDeepWith = _interopRequireDefault(require("lodash/cloneDeepWith"));

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var _orderBy = _interopRequireDefault(require("lodash/orderBy"));

var _sift = _interopRequireDefault(require("sift"));

var _reorder = require("./reorder");

var MemoryStore =
/*#__PURE__*/
function (_Store) {
  (0, _inherits2.default)(MemoryStore, _Store);

  function MemoryStore() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, MemoryStore);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(MemoryStore)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_className", 'MemoryStore');
    return _this;
  }

  (0, _createClass2.default)(MemoryStore, [{
    key: "_create",
    value: function _create(props) {
      var _this2 = this;

      (0, _get2.default)((0, _getPrototypeOf3.default)(MemoryStore.prototype), "_create", this).call(this, props);
      this._docs = new _storeMapa.default();

      this._docs.on('$change', function (name, value) {
        _this2.emitChange(name + 'Doc', value);
      });
    }
  }, {
    key: "_numUnarchived",
    value: function _numUnarchived() {
      var n = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this._docs.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var value = _step.value;

          if (!value.archivedAt) {
            n++;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return n;
    }
  }, {
    key: "_createDoc",
    value: function () {
      var _createDoc2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(_ref) {
        var fieldValues, id, order, reorder, userId, doc;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fieldValues = _ref.fieldValues, id = _ref.id, order = _ref.order, reorder = _ref.reorder;

                if (this._shouldSetToLastOrder(order, reorder)) {
                  order = this._numUnarchived();
                }

                userId = this._getUserId();
                doc = this._buildDoc({
                  fieldValues: fieldValues,
                  id: id,
                  order: order,
                  userId: userId
                });

                this._docs.set(doc.id, doc, undefined, undefined, true);

                return _context.abrupt("return", doc);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _createDoc(_x) {
        return _createDoc2.apply(this, arguments);
      }

      return _createDoc;
    }()
  }, {
    key: "_toSiftWhere",
    value: function _toSiftWhere(where) {
      return (0, _cloneDeepWith.default)(where, function (doc) {
        if (doc && doc.$iLike) {
          return {
            $regex: '^' + doc.$iLike.replace(/%/, ''),
            $options: 'i'
          };
        }
      });
    }
  }, {
    key: "_hasDoc",
    value: function () {
      var _hasDoc2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(_ref2) {
        var id;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                id = _ref2.id;
                return _context2.abrupt("return", this._docs.has(id));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _hasDoc(_x2) {
        return _hasDoc2.apply(this, arguments);
      }

      return _hasDoc;
    }()
  }, {
    key: "_getDoc",
    value: function () {
      var _getDoc2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(_ref3) {
        var id;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                id = _ref3.id;
                return _context3.abrupt("return", this._docs.get(id));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _getDoc(_x3) {
        return _getDoc2.apply(this, arguments);
      }

      return _getDoc;
    }()
  }, {
    key: "_getAllDocs",
    value: function () {
      var _getAllDocs2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(_ref4) {
        var where, showArchived, order, docs, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, doc, sifted, names, orders;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                where = _ref4.where, showArchived = _ref4.showArchived, order = _ref4.order;

                // TODO: after, first, before, last and cursors in results
                if (where) {
                  // Convert to a sift expression and then filter
                  where = this._toSiftWhere(where);
                }

                docs = {
                  // TODO: hasNextPage will need to change once we support pagination via after, first, etc...
                  // depending on if there is still more data to get
                  pageInfo: {
                    hasNextPage: false
                  },
                  edges: []
                };
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context4.prev = 6;

                for (_iterator2 = this._docs.values()[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  doc = _step2.value;
                  sifted = where === undefined ? null : (0, _sift.default)(where, [doc]);

                  if ((showArchived === null || showArchived === undefined || !!doc.archivedAt === showArchived) && (where === undefined || sifted.length !== 0)) {
                    docs.edges.push({
                      node: doc
                    });
                  }
                }

                _context4.next = 14;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](6);
                _didIteratorError2 = true;
                _iteratorError2 = _context4.t0;

              case 14:
                _context4.prev = 14;
                _context4.prev = 15;

                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                  _iterator2.return();
                }

              case 17:
                _context4.prev = 17;

                if (!_didIteratorError2) {
                  _context4.next = 20;
                  break;
                }

                throw _iteratorError2;

              case 20:
                return _context4.finish(17);

              case 21:
                return _context4.finish(14);

              case 22:
                if (order) {
                  // Order by properties
                  names = [];
                  orders = [];
                  order.forEach(function (order) {
                    names.push('node.' + order[0]);
                    orders.push(order[1].toLowerCase());
                  });
                  docs.edges = (0, _orderBy.default)(docs.edges, names, orders);
                }

                return _context4.abrupt("return", docs);

              case 24:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[6, 10, 14, 22], [15,, 17, 21]]);
      }));

      function _getAllDocs(_x4) {
        return _getAllDocs2.apply(this, arguments);
      }

      return _getAllDocs;
    }()
  }, {
    key: "_updateDoc",
    value: function () {
      var _updateDoc2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(_ref5) {
        var id, fieldValues, order, doc;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                id = _ref5.id, fieldValues = _ref5.fieldValues, order = _ref5.order;
                // Clone the data so that we don't modify the original
                doc = (0, _cloneDeep.default)(this._docs.get(id));
                doc = this._setDoc({
                  doc: doc,
                  fieldValues: fieldValues,
                  order: order
                });

                this._docs.set(id, doc, undefined, undefined, true);

                return _context5.abrupt("return", doc);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _updateDoc(_x5) {
        return _updateDoc2.apply(this, arguments);
      }

      return _updateDoc;
    }()
  }, {
    key: "_archiveDoc",
    value: function () {
      var _archiveDoc2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(_ref6) {
        var id, doc;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                id = _ref6.id;
                // Clone the data so that we don't modify the original
                doc = (0, _cloneDeep.default)(this._docs.get(id));
                doc = this._setDoc({
                  doc: doc,
                  archivedAt: this._now(),
                  order: _reorder.Reorder.DEFAULT_ORDER
                });

                this._docs.set(id, doc, undefined, undefined, true);

                return _context6.abrupt("return", doc);

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function _archiveDoc(_x6) {
        return _archiveDoc2.apply(this, arguments);
      }

      return _archiveDoc;
    }()
  }, {
    key: "_restoreDoc",
    value: function () {
      var _restoreDoc2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(_ref7) {
        var id, reorder, order, doc;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                id = _ref7.id, reorder = _ref7.reorder, order = _ref7.order;

                if (this._shouldSetToLastOrder(order, reorder)) {
                  order = this._numUnarchived();
                } // Clone the data so that we don't modify the original


                doc = (0, _cloneDeep.default)(this._docs.get(id));
                doc = this._setDoc({
                  doc: doc,
                  archivedAt: null,
                  order: order
                });

                this._docs.set(id, doc, undefined, undefined, true);

                return _context7.abrupt("return", doc);

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function _restoreDoc(_x7) {
        return _restoreDoc2.apply(this, arguments);
      }

      return _restoreDoc;
    }()
  }]);
  return MemoryStore;
}(_store.default);

exports.default = MemoryStore;